<template>
  <div class="pb-10 flex justify-between items-center">
    <!-- <gd-dropdown
          class="custom-selectbox w-30"
          :placeholder="$t('frontend_all_categories')"
          :options="[]"
        ></gd-dropdown> -->
    <div class="relative w-96">
      <text-input class="h-10" placeholder="Find a course" />
      <i class="fas fa-search absolute right-0 top-0 mr-3 mt-3"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'filters',
};
</script>
<style lang="scss">
.membership-layout-container .custom-selectbox,
.custom-selectbox.h-10 {
  height: 40px;
  .border-solid.cursor-pointer {
    font-size: 14px;
    height: 40px;
    background-color: #fff;
    border-color: #d5d8e5;
    border-radius: 6px;
    .select-none {
      padding: 0 12px;
      color: #000;
    }
  }
  svg {
    color: #191d3a;
    height: 20px;
    top: 2px;
    pointer-events: none;
  }
  .italic.select-none {
    display: none;
  }
}
.custom-selectbox.h-10 .italic.select-none {
  display: block;
}
</style>
<style lang="scss" scoped>
.search-input {
  svg {
    position: absolute;
    right: 14px;
    top: 12px;
    color: #000;
  }
}
</style>
